import type { LucideIcon } from 'lucide-react'

import { Bot, Braces, Workflow, Waypoints } from 'lucide-react'

export interface NavLink {
    label: string
    href: string
}

export interface PlatformProduct {
    id: string
    name: string
    description: string
    href: string
    icon: LucideIcon
}

export const platformProducts: Array<PlatformProduct> = [
    {
        id: 'managed-flows',
        name: "Managed Flows",
        description: "Custom integrations, built and run for you",
        href: '/platform#managed-flows',
        icon: Workflow
    },
    {
        id: 'flow-studio',
        name: "Flow Studio",
        description: "Design and automate flows visually",
        href: '/platform#flow-studio',
        icon: Waypoints
    },
    {
        id: 'pilot',
        name: "Pilot",
        description: "An AI teammate for daily ops",
        href: '/platform#pilot',
        icon: Bot
    },
    {
        id: 'open-api',
        name: "Open API",
        description: "One connection to 3,400+ carriers and systems",
        href: '/platform#open-api',
        icon: Braces
    }
]

export const mainNav: Array<NavLink> = [
    { label: "Network", href: '/network' },
    { label: "Industries", href: '/industries' },
    { label: "Journal", href: '/journal' },
    { label: "Company", href: '/company' }
]

export interface FooterColumn {
    title: string
    links: Array<NavLink>
}

export const footerColumns: Array<FooterColumn> = [
    {
        title: "Platform",
        links: [
            { label: "Managed Flows", href: '/platform#managed-flows' },
            { label: "Flow Studio", href: '/platform#flow-studio' },
            { label: "Pilot", href: '/platform#pilot' },
            { label: "Open API", href: '/platform#open-api' },
            { label: "Network directory", href: '/network' }
        ]
    },
    {
        title: "Industries",
        links: [
            { label: "Retail and e-commerce", href: '/industries#retail-and-e-commerce' },
            { label: "Manufacturing", href: '/industries#manufacturing' },
            { label: "Food and beverage", href: '/industries#food-and-beverage' },
            { label: "Automotive parts", href: '/industries#automotive-parts' },
            { label: "Third-party logistics", href: '/industries#third-party-logistics' },
            { label: "ERP integrations", href: '/integrations/erp' }
        ]
    },
    {
        title: "Company",
        links: [
            { label: "About", href: '/company' },
            { label: "Journal", href: '/journal' },
            { label: "Contact", href: '/contact' },
            { label: "Speak to a human", href: '/contact#speak-to-a-human' },
            { label: "System status", href: '/contact#system-status' },
            { label: "Partner with Quayside", href: '/company#partners' },
            { label: "Trust Center", href: '/trust' },
            { label: "Privacy Policy", href: '/privacy' },
            { label: "Terms", href: '/terms' }
        ]
    }
]
